import { Pipe, PipeTransform } from '@angular/core';
import { TimeLeftTranslationService } from './time-left-translation.service';
import { TranslationService } from '@schoolbelle/common/translation';
import { reduce } from 'lodash-es';

@Pipe({
  name: 'timeLeft',
})
export class TimeLeftPipe implements PipeTransform {
    constructor (
        private questionTypeSerivce: TimeLeftTranslationService, // must be here. don't touch it.
        private translationService:TranslationService,
    ) {
    }
    transform(value: number, args?:{day:string, days:string, hour:string, hours:string, minute:string, minutes:string, second:string, seconds:string}): any {
        if (!value) {
            return '';
        }
        
        let str = '';
        let ms = value;
        if (ms >= 0) {
            let s = Math.floor(ms/1000)%60;
            let m = Math.floor(ms/(1000*60))%60;
            let h = Math.floor(ms/(1000*60*60))%24;
            let d = Math.floor(ms/(1000*60*60*24));
            if(d !== 0) str += ' ' + d + (args && args[d === 1 ? 'day':'days'] || this.translationService.get(d === 1 ? 'day':'days'));
            if(d !== 0 || h !== 0) str += ' ' + ('00' + h).slice(-2) + (args && args[h === 1 ? 'hour':'hours'] || this.translationService.get(h === 1 ? 'hour':'hours'));
            if(d !== 0 || h !== 0 || m !== 0) str += ' ' + ('00' + m).slice(-2) + (args && args[h === 1 ? 'minute':'minutes'] || this.translationService.get(m === 1 ? 'minute':'minutes'));
            if(d !== 0 || h !== 0 || m !== 0 || s !== 0) str += ' ' + ('00' + s).slice(-2) + (args && args[h === 1 ? 'second':'seconds'] || this.translationService.get(s === 1 ? 'second':'seconds'));
        }
        return str;
        
    }


}

